import { useDateFormatSelect } from "store";
import { PreviewDateRangeUtil } from "store/types";
import { previewDateRange } from "utils";

export function useRenderDateValue(): PreviewDateRangeUtil {
  const dateFormat = useDateFormatSelect();

  return ({ format = dateFormat, ...rest }): string => {
    return previewDateRange({ format, ...rest });
  };
}
